import React from 'react'
// import { useTranslation } from 'react-i18next'
import { Button, Checkbox, Select, TextInput } from 'components/Form'
import { BiSearchAlt } from 'react-icons/bi'
import { AiFillCaretDown, AiFillCaretUp, AiFillPlusCircle, AiOutlinePlus } from 'react-icons/ai'
import { FiDownload } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { filterOptions, lengthOption, productOptions } from 'utils/options'
import { useSelector } from 'react-redux'
import { exportToCSV } from 'utils/csvExport'

const defoltclassName = 'py-2 px-2 md:px-4 2xl:px-7'

const Table = ({
    columns,
    loading,
    datas,
    add_new,
    bulk_add = '',
    link,
    link_name,
    search_show = true,
    is_show = true,
    filter = true,
    extraFilter = false,
    companyFilter = false,
    branchFilter = false,
    categoryFilter = false,
    select = false,
    buttons = [],
    name = 'datas',
    onChange,
    pagingData,
    ids,
    setIds,
    grid = 'sm:flex-row sm:justify-between',
    subGrid = 'sm:flex-row sm:justify-between',
    children,
    // A1 — CSV export. Default ON; pass `csvExport={false}` to opt out.
    csvExport = true,
    exportFilename,
    // Custom getter so a parent can stream the *full* server-paginated
    // dataset rather than the page currently in `datas`. Returns an array.
    onExport,
}) => {
    // const { t } = useTranslation()

    const { pageSize, pageIndex, total, sort, query, selectedTab, addon, branch, company, category } = pagingData
    const { branchData, companyData } = useSelector(state => state.listData)
    const userInfo = useSelector(state => state.auth.user)

    var totalPage = Math.ceil(total / pageSize)
    var pages = []
    var loadingPages = ['Previous', '...', 'Next']
    const from = pageSize * (pageIndex - 1) + 1
    const to = total > pageSize * pageIndex ? pageSize * pageIndex : total

    for (let i = 1; i <= totalPage; i++) {
        if (i === 1) {
            pages.push('Previous')
            pages.push(i)
        } else if (i === totalPage) {
            pages.push(i)
            pages.push('Next')
        } else {
            pages.push(i)
        }
    }

    const ColumnTd = ({ row, column }) => {
        return (
            <td
                className={`border-b border-stroke dark:border-strokedark items-center text-sm text-black dark:text-white ${defoltclassName} ${column.className}`}
            >
                {column.renderCell ? column.renderCell(row) : row[column.field]}
            </td>
        )
    }
    const gridClass = `flex flex-col items-center gap-3 ${grid}`
    const subGridClass = `flex flex-col items-center gap-3 ${subGrid}`

    const onPaginationChange = page => {
        const newTableData = { ...pagingData }
        newTableData.pageIndex = page
        onChange(newTableData)
    }

    const onSelectChange = val => {
        const newTableData = { ...pagingData }
        newTableData.pageSize = val
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onSort = sort => {
        const newTableData = { ...pagingData }
        newTableData.sort = sort
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onSearch = val => {
        const newTableData = { ...pagingData }
        newTableData.query = val
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onTabChange = value => {
        const newTableData = { ...pagingData }
        newTableData.selectedTab = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onAddonChange = value => {
        const newTableData = { ...pagingData }
        newTableData.addon = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onBranchChange = value => {
        const newTableData = { ...pagingData }
        newTableData.branch = [value]
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onCompanyChange = value => {
        const newTableData = { ...pagingData }
        newTableData.company = value
        newTableData.branch = ''
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onCategoryChange = value => {
        const newTableData = { ...pagingData }
        newTableData.category = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    return (
        <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className={`p-3 md:p-4 xl:p-6 ${gridClass}`}>
                <div className={subGridClass}>
                    {is_show && (
                        <div className="flex flex-row items-center gap-2">
                            <p className="text-black dark:text-white">{'Show'}</p>
                            <Select
                                id="length"
                                name="length"
                                value={pageSize ?? 10}
                                className="w-17"
                                options={lengthOption}
                                onChange={e => onSelectChange?.(e.target.value)}
                            />
                            <p className="text-black dark:text-white">{'Entries'}</p>
                        </div>
                    )}
                    {children}
                </div>
                <div className={subGridClass}>
                    {buttons.length > 0 && (
                        <div className="flex flex-row items-center gap-3">
                            {buttons.map((text, index) => (
                                <Button
                                    key={index}
                                    as="a"
                                    // href={url}
                                    data={{ download: text }}
                                    // onClick={() => download(text)}
                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                >
                                    {text}
                                </Button>
                            ))}
                        </div>
                    )}
                    {extraFilter && (
                        <Select
                            id="length"
                            name="length"
                            value={addon}
                            className="min-w-28"
                            options={productOptions}
                            onChange={e => onAddonChange?.(e.target.value)}
                        />
                    )}
                    {companyFilter && (
                        <Select
                            id="length"
                            name="length"
                            placeholder="Company"
                            value={company}
                            className="min-w-28"
                            options={companyData}
                            onChange={e => onCompanyChange?.(e.target.value)}
                        />
                    )}
                    {branchFilter && (
                        <Select
                            id="length"
                            name="length"
                            placeholder="Branch"
                            value={branch ? branch[0] : ''}
                            className="min-w-28"
                            options={
                                userInfo?.branches?.length > 1
                                    ? userInfo?.branches
                                    : branchData?.filter(item => (company ? item?.company?.id?.toString() === company : item))
                            }
                            onChange={e => onBranchChange?.(e.target.value)}
                        />
                    )}
                    {categoryFilter && (
                        <Select
                            id="length"
                            name="length"
                            placeholder="Category"
                            value={category}
                            className="min-w-28"
                            options={branchData}
                            onChange={e => onCategoryChange?.(e.target.value)}
                        />
                    )}
                    {filter && (
                        <Select
                            id="length"
                            name="length"
                            value={selectedTab}
                            className="min-w-28"
                            options={filterOptions}
                            onChange={e => onTabChange?.(e.target.value)}
                        />
                    )}
                    {search_show && (
                        <TextInput
                            id="search"
                            name="search"
                            value={query ?? ''}
                            onChange={e => onSearch?.(e.target.value)}
                            placeholder={'Search'}
                            icon={<BiSearchAlt />}
                            className="w-full sm:w-auto"
                        />
                    )}
                    {csvExport && (
                        <Button
                            as="button"
                            type="button"
                            aria-label={`Export ${name} to CSV`}
                            className="text-primary border-primary dark:text-secondary dark:border-secondary flex items-center gap-1.5"
                            onClick={async () => {
                                try {
                                    const rows = onExport ? await onExport() : datas
                                    exportToCSV(rows || [], exportFilename || name, columns)
                                } catch (_e) {
                                    // Helper is best-effort; nothing to surface.
                                }
                            }}
                        >
                            <FiDownload size={16} aria-hidden="true" /> CSV
                        </Button>
                    )}
                    {(link || add_new) && (
                        <div className="flex flex-row items-center w-full gap-3 sm:w-auto">
                            {link && (
                                <Button
                                    href={link}
                                    as="button"
                                    className="text-primary border-primary dark:text-secondary dark:border-secondary"
                                >
                                    {link_name}
                                </Button>
                            )}
                            {add_new && (
                                <Link to={add_new}>
                                    <Button
                                        as="button"
                                        className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    >
                                        <AiOutlinePlus size={20} /> {'Add New'}
                                    </Button>
                                </Link>
                            )}

                            {bulk_add && (
                                <Link to={bulk_add}>
                                    <Button
                                        as="button"
                                        className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    >
                                        <AiFillPlusCircle size={20} /> {' Bulk Add'}
                                    </Button>
                                </Link>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="max-w-full overflow-x-auto">
                <table className="w-full table-auto">
                    <thead>
                        <tr className={`bg-primary dark:bg-secondary bg-opacity-90 text-left`}>
                            {select && (
                                <th className="px-3 py-2 font-medium text-white md:px-3 2xl:px-3">
                                    <Checkbox
                                        id={'select_all'}
                                        name={'select_all'}
                                        checked={datas?.length !== 0 && datas?.length === ids.length}
                                        onChange={() => setIds(datas?.length !== ids.length ? datas?.map(row => row.id) : [])}
                                    />
                                </th>
                            )}
                            {columns.map((row, index) => (
                                <th
                                    key={index}
                                    scope="col"
                                    aria-sort={
                                        row.orderable
                                            ? sort[0].column === row.field
                                                ? sort[0].dir === 'asc' ? 'ascending' : 'descending'
                                                : 'none'
                                            : undefined
                                    }
                                    className={`font-medium text-white ${defoltclassName} ${row.className}`}
                                >
                                    {row.orderable ? (
                                        <button
                                            type="button"
                                            className="flex items-center justify-between gap-1 w-full focus:outline-none focus:ring-2 focus:ring-white focus:ring-inset rounded"
                                            onClick={() => {
                                                if (sort[0].dir !== 'desc') {
                                                    const data = [
                                                        {
                                                            column: row.field,
                                                            dir:
                                                                sort[0].column === row.field && sort[0].dir === 'asc'
                                                                    ? 'desc'
                                                                    : 'asc',
                                                        },
                                                    ]
                                                    onSort?.(data)
                                                } else {
                                                    onSort?.([{ column: '', dir: '' }])
                                                }
                                            }}
                                        >
                                            <p>{row.header}</p>
                                            <div aria-hidden="true" className="inline-flex flex-col space-y-[2px]">
                                                {(sort[0].column !== row.field || sort[0].dir !== 'asc') && (
                                                    <AiFillCaretUp size={14} style={{ margin: '-1px' }} />
                                                )}
                                                {(sort[0].column !== row.field || sort[0].dir !== 'desc') && (
                                                    <AiFillCaretDown size={14} style={{ margin: '-1px' }} />
                                                )}
                                            </div>
                                        </button>
                                    ) : (
                                        row.header
                                    )}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {datas?.map((row, index) => (
                            <tr key={index} className="hover:bg-whiten dark:hover:bg-boxdark2">
                                {select && (
                                    <td className="items-center px-3 py-2 text-sm text-black border-b border-stroke dark:border-strokedark dark:text-white md:px-3 2xl:px-3">
                                        <Checkbox
                                            id={'select_' + row.id}
                                            name={'select_' + row.id}
                                            checked={ids.includes(row.id)}
                                            onChange={() => {
                                                var selectIds = [...ids]
                                                if (!selectIds.includes(row.id)) {
                                                    selectIds.push(row.id)
                                                } else {
                                                    selectIds = selectIds.filter(g => g !== row.id)
                                                }
                                                setIds(selectIds)
                                            }}
                                        />
                                    </td>
                                )}
                                {columns.map((column, key) => (
                                    <ColumnTd key={key} row={row} column={column} />
                                ))}
                            </tr>
                        ))}
                        {datas?.length === 0 && (
                            <tr>
                                <td
                                    className={`border-b border-stroke dark:border-strokedark items-center text-center text-primary dark:text-white ${defoltclassName}`}
                                    colSpan="100%"
                                >
                                    <span role="status" aria-live="polite">
                                        {loading ? 'Loading...' : 'Data not found'}
                                    </span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {(totalPage > 1 || loading) && (
                <div className="flex flex-col gap-3 p-3 sm:p-4 xl:p-6 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-sm text-black dark:text-white">
                        {`Showing ${from} to 
                        ${to} of ${total} entries`}
                    </p>
                    <nav aria-label="Table pagination">
                        <ul className="flex flex-wrap items-center w-full">
                            {(loading ? loadingPages : pages)?.map((link, key) => {
                                const isCurrent = link === pageIndex
                                const isDisabled = loading ||
                                    (link === 'Previous' && pageIndex === 1) ||
                                    (link === 'Next' && pageIndex === totalPage)
                                const ariaLabel = link === 'Previous' ? 'Previous page'
                                    : link === 'Next' ? 'Next page'
                                    : `Page ${link}`
                                return (
                                    <li key={key}>
                                        <button
                                            type="button"
                                            aria-label={ariaLabel}
                                            aria-current={isCurrent ? 'page' : undefined}
                                            disabled={isDisabled}
                                            onClick={() => {
                                                if (isDisabled) return
                                                if (link === 'Previous') onPaginationChange(pageIndex - 1)
                                                else if (link === 'Next') onPaginationChange(pageIndex + 1)
                                                else onPaginationChange(link)
                                            }}
                                            className={`flex items-center justify-center border py-[5px] px-4 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset
                                                ${key !== 0 && !isCurrent && 'border-l-transparent'}
                                                ${isCurrent
                                                    ? 'border-primary bg-gray text-primary dark:border-secondary dark:bg-graydark'
                                                    : 'text-black dark:text-white border-stroke hover:border-primary hover:bg-gray hover:text-primary dark:hover:text-secondary dark:border-strokedark dark:hover:border-secondary dark:hover:bg-graydark'}
                                                ${isDisabled && 'opacity-40 cursor-not-allowed'}
                                                ${key === 0 && 'rounded-l-md'}
                                                ${pages.length === key + 1 && 'rounded-r-md'}
                                            `}
                                        >
                                            {link}
                                        </button>
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                </div>
            )}
        </div>
    )
}
export default Table
